module.exports = __webpack_public_path__ + "img/particularsBanner.c1a37d6b.png";